import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { adsMinuteMedia } from '../../../../catalog/Ads';
import { sendCustomAnalytics } from '../../../../catalog/Analytics';

const AdComponent1Header = (props) => {
    const { show, containerId, sizes, placementId } = props;

    const IBASizes = {
        square: { width: '250', height: '250' },
        squareButton: { width: '125', height: '125' },
        medRec: { width: '300', height: '250' },
        vertRec: { width: '240', height: '400' },
        rec: { width: '180', height: '150' },
        largeRec: { width: '336', height: '280' },
        halfBanner: { width: '234', height: '60' },
        fullBanner: { width: '468', height: '60' },
        popUnder: { width: '720', height: '300' },
        leaderBoard: { width: '728', height: '90' },
        '31Rec': { width: '300', height: '100' },
        halfPage: { width: '300', height: '600' },
        wideSkyScraper: { width: '160', height: '600' },
        skyScraper: { width: '120', height: '600' },
        billboard: { width: '970', height: '250' },
        smartphone1: { width: '320', height: '50' },
        smartphone2: { width: '300', height: '50' },
    };

    const getSizes = () => {
        let str = '';
        sizes.forEach((size) => {
            str += `[${IBASizes[size].width}, ${IBASizes[size].height}],`;
        });
        return str;
    };

    useEffect(() => {
        const script = document.createElement('script');

        if (show) {
            const javascriptCode = `
            var adUnits = [{
                code: '${containerId}',
                mediaTypes: {
                    banner: {
                        sizes: [
                            ${getSizes()}
                        ]
                    }
                },
                bids: [{
                    bidder: 'minutemedia',
                    params: {
                        org: '${adsMinuteMedia.organizationId}',
                        floorPrice: ${adsMinuteMedia.floorPrice},
                        placementId: '${placementId}',
                        testMode: ${adsMinuteMedia.testMode},
                    },
                }],
            }];
            
            var pbjs = pbjs || {};
            pbjs.que = pbjs.que || [];
            
            pbjs.que.push(function () {
                pbjs.setConfig({
                    debug: false
                })
                pbjs.addAdUnits(adUnits);
                pbjs.requestBids({
                    bidsBackHandler: renderAllAdUnits,
                    timeout: 1000
                });
            });

            function renderAllAdUnits() {
                var winners = pbjs.getHighestCpmBids();
                console.log(winners)
                console.log("${containerId}")
                for (var i = 0; i < winners.length; i++) {
                    renderOne(winners[i]);
                }
            }
                
            function renderOne(winningBid) {
                if (${show} && winningBid && winningBid.adId && winningBid.adUnitCode) {
                    var div = document.getElementById(winningBid.adUnitCode);
                    var iframe = document.getElementById(\`iframe-\${winningBid.adUnitCode}\`);
                    if (div && !iframe) {
                        const iframe = document.createElement('iframe');
                        iframe.id = \`iframe-\${winningBid.adUnitCode}\`
                        iframe.scrolling = 'no';
                        iframe.frameBorder = '0';
                        iframe.marginHeight = '0';
                        iframe.marginHeight = '0';
                        iframe.name = winningBid.adUnitCode;
                        iframe.title = '3rd party ad content';
                        iframe.sandbox.add(
                            'allow-forms',
                            'allow-popups',
                            'allow-popups-to-escape-sandbox',
                            'allow-same-origin',
                            'allow-scripts',
                            'allow-top-navigation-by-user-activation',
                        );
                        iframe.setAttribute('aria-label', 'Advertisment');
                        iframe.style.setProperty('border', '0');
                        iframe.style.setProperty('margin', '10px');
                        iframe.style.setProperty('overflow', 'hidden');
                        div.appendChild(iframe);
                        const iframeDoc = iframe.contentWindow.document;
                        pbjs.renderAd(iframeDoc, winningBid.adId);
            
                        const normalizeCss = '/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */button,hr,input{overflow:visible}progress,sub,sup{vertical-align:baseline}[type=checkbox],[type=radio],legend{box-sizing:border-box;padding:0}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}details,main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:ButtonText dotted 1px}fieldset{padding:.35em .75em .625em}legend{color:inherit;display:table;max-width:100%;white-space:normal}textarea{overflow:auto}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}[hidden],template{display:none}';
                        const iframeStyle = iframeDoc.createElement('style');
                        iframeStyle.appendChild(iframeDoc.createTextNode(normalizeCss));
                        iframeDoc.head.appendChild(iframeStyle);
                    }
                }
            }`;

            script.type = 'text/javascript';

            script.textContent = javascriptCode;

            document.body.appendChild(script);

            sendCustomAnalytics('ads', { placementId });
        }

        return () => {
            if (show) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return (
        <>
        </>
    );
};

AdComponent1Header.propTypes = {
    show: PropTypes.bool,
    containerId: PropTypes.string,
    sizes: PropTypes.array,
    placementId: PropTypes.string,
};
AdComponent1Header.defaultProps = {
    show: true,
    containerId: 'ads-container',
    sizes: ['leaderBoard', 'billboard', 'popUnder'],
    placementId: '',
};

export default AdComponent1Header;
